import React from 'react';
import styled from 'styled-components';

import BaseInnerWrapper from '../../../global/InnerWrapper';
import P from '../../../global/typography/P';
import Heading from './Heading';

import { swatches, media } from '../../../../styles/theme';

const BreakpointDesktop = '(max-width: 1100px)';
const BreakpointMobile = media.mobilePhone;

const ColumnOne = styled.div`
  padding: 25px 0 0;
  width: 40%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media ${BreakpointDesktop} {
    width: 100%;
    order: 1;
  }
`;

const ColumnTwo = styled.div`
  padding: 60px 0 0;
  width: 60%;

  @media ${BreakpointDesktop} {
    width: 100%;
  }
`;

const SectionHeading = styled(Heading)`
  @media ${BreakpointMobile} {
    font-size: 18px;
    font-weight: 800;
  }
`;

const Image = styled.img`
  max-width: 430px;

  @media ${BreakpointMobile} {
    margin: 0 auto;
    width: 95%;
  }
`;

const InnerWrapper = styled(BaseInnerWrapper)`
  display: ${p => p.display};
  flex-wrap: wrap;
`;

const List = styled.ul`
  list-style: none;
`;

const ListItem = styled(P)`
  margin-bottom: 27px;
  color: ${swatches.white};
  position: relative;

  &::before {
    padding-right: 30px;
    position: absolute;
    display: inline-block;
    top: 6px;
    right: 100%;
    height: 12px;
    width: 14px;
    content: '';
    background-image: url('/customProduct/CustomArrows.png');
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

const Logo = styled(Image)`
  margin-bottom: 16px;
  max-width: 324px;

  @media ${BreakpointDesktop} {
    display: none;
  }
`;

const LogoMobile = styled.img`
  display: none;
  margin: 0 auto 60px;
  max-width: 324px;

  @media ${BreakpointDesktop} {
    display: flex;
  }
`;

const RedHighlight = styled.span`
  color: ${swatches.primary};
`;

const Paragraph = styled(P)`
  margin-bottom: 27px;
  color: ${swatches.offwhite};
`;

const Wrapper = styled.section`
  background-color: ${swatches.black};
`;

export default () => (
  <Wrapper>
    <InnerWrapper display="flex">
      <ColumnOne>
        <Logo src="/customProduct/NobleCustomConxusLogo.png" />
        <Image src="/customProduct/NobleCustomPhone.png" />
      </ColumnOne>
      <ColumnTwo>
        <InnerWrapper display="block">
          <LogoMobile src="/customProduct/NobleCustomConxusLogo.png" />
          <SectionHeading>
            Control <RedHighlight>From Anywhere</RedHighlight>
          </SectionHeading>
          <Paragraph>
            From wherever you are, the CON·X·US option lets you use any
            Internet-capable device to link up with any SMART SYSTEM branded
            control on an unlimited number of applicable units. With CON·X·US,
            you’re always in touch and in control. Do regular CON·X·US checks
            for all your customers, and let them know you’re monitoring their
            unit’s performance.
          </Paragraph>
          <List>
            <ListItem as="li">
              Adjust setpoints, domestic hot water, reset curves, pump delays
              and more, using the CON·X·US interactive display.
            </ListItem>
            <ListItem as="li">
              Status alerts via text or e-mail let you know when equipment needs
              attention.
            </ListItem>
          </List>
        </InnerWrapper>
      </ColumnTwo>
    </InnerWrapper>
  </Wrapper>
);
